import React from "react";

let style = {
  position: "fixed",
  zIndex: 1000,
  cursor: "pointer",
  bottom: 0,
  right: 0,
  background: "green",
  color: "white",
  border: "none",
  padding: "4px",
  fontFamily: "sans-serif",
  fontSize: "12px"
};

export function DevRefreshButton() {
  if (process.env.GATSBY_ENV !== "development") {
    return null;
  }

  function refreshOrReload() {
    var oReq = new XMLHttpRequest();
    oReq.open("POST", "/__refresh");
    oReq.send();
  }

  return (
    <button onClick={refreshOrReload} style={style}>
      Refresh
    </button>
  );
}
